import { useState } from "react";
import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
} from "V2.0/common/dropdown";

import CloneAudio from "./CloneAudio";
import Prompt from "./Prompt";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { TbPrompt } from "react-icons/tb";
import { BsFiletypeMp3 } from "react-icons/bs";

enum VoiceDesignOption {
  Prompt = "Prompt",
  Clone = "Clone Audio",
}

const VoiceDesignRegistry = {
  [VoiceDesignOption.Prompt]: (props) => <Prompt {...props} />,
  [VoiceDesignOption.Clone]: (props) => <CloneAudio {...props} />,
};

const VoiceDesignOptionIcon = {
  [VoiceDesignOption.Prompt]: <TbPrompt />,
  [VoiceDesignOption.Clone]: <BsFiletypeMp3 />,
};

interface VoiceDesignProps {
  fetchVoices: () => void;
}

export default function VoicesDesignV2(props: VoiceDesignProps) {
  const { fetchVoices } = props;

  const [designMode, setDesignMode] = useState<VoiceDesignOption>(null);

  return (
    <>
      <Dropdown>
        <DropdownButton outline>
          <PencilSquareIcon /> Design Voice
        </DropdownButton>

        <DropdownMenu className="">
          <DropdownItem onClick={() => setDesignMode(VoiceDesignOption.Prompt)}>
            <div className="flex items-center space-x-2">
              {VoiceDesignOptionIcon[VoiceDesignOption.Prompt]}
              <p>Prompt</p>
            </div>
          </DropdownItem>
          <DropdownItem onClick={() => setDesignMode(VoiceDesignOption.Clone)}>
            <div className="flex items-center space-x-2">
              {VoiceDesignOptionIcon[VoiceDesignOption.Clone]}
              <p>Clone Audio</p>
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {designMode &&
        VoiceDesignRegistry[designMode]({
          fetchVoices,
          onClose: () => setDesignMode(null),
        })}
    </>
  );
}
